// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"a638cc30","28":"7460ea3a","144":"59adbc3d","195":"857653df","212":"6d81d46b","222":"f0ac5bc1","348":"2af5aa63","465":"401abce0","539":"fd04afc6","621":"6d416ab7","703":"678a18be","736":"c03bef0d","845":"f9c9a13b","929":"33e78a16","933":"87a17ccc"}[chunkId] + ".chunk.js";
};